import { DateTime } from "luxon";

export const formatDate = (dateString: string | Date | undefined | null): string => {
  if (!dateString) return "-";
  const dt =
    typeof dateString === "string"
      ? DateTime.fromISO(dateString)
      : DateTime.fromJSDate(dateString);
  if (!dt.isValid) return "-";
  return dt.toFormat("yyyy-MM-dd");
};

export const formatDateTime = (dateString: string | Date | undefined | null): string => {
  if (!dateString) return "-";
  const dt =
    typeof dateString === "string"
      ? DateTime.fromISO(dateString)
      : DateTime.fromJSDate(dateString);
  if (!dt.isValid) return "-";
  return dt.toFormat("yyyy-MM-dd HH:mm:ss");
};

export const toDateString = (d: Date): string =>
  DateTime.fromJSDate(d).toISODate() ?? "";

export const formatPeriod = (period: string | undefined | null): string => {
  if (!period || period.length < 7) return "-";
  const dt = DateTime.fromFormat(period, "yyyy-MM");
  if (!dt.isValid) return period;
  return dt.toLocaleString({ year: "numeric", month: "long" });
};
